// React-Query hook для Sprint 5 A-S5-1 GET /dashboard.
// Source of truth: docs/specs/sprint-5/stage-4-frontend.md §2.3.1 + stage-1-contracts.md §6.5.
//
// enabled-контракт (RF-S5-30):
//   - useOnboardingState ОБЯЗАН передавать enabled: shouldCheckDashboard
//     (см. R-S5-2). Без gate'а backend вернёт 403 на pre-survey states.
//   - Pages (s4/s5/s15) за RequireSurveyCompleted — опускают опцию.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';
import type { DashboardResponse } from '@/api/types';

export function useDashboard(
  options?: { enabled?: boolean },
): UseQueryResult<DashboardResponse> {
  return useQuery({
    queryKey: queryKeys.dashboard,
    queryFn: async () => {
      // RF-S5-S4-1: baseURL уже = `${VITE_API_URL}/api/v1` ([client.ts:8]) —
      // relative path БЕЗ префикса '/api/v1'.
      const { data } = await api.get<DashboardResponse>('/dashboard');
      return data;
    },
    enabled: options?.enabled ?? true,
  });
}
